import interceptedAxios from '../../../utils/interceptedAxios'
import { z } from 'zod'

const ZUploadFile = z.object({
  deviceTemplateId: z.string().nullable(),
  message: z.string().nullable()
})

const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  error_message: z.optional(z.string()),
  data: z.optional(ZUploadFile)
})

export type UploadFile = z.infer<typeof ZUploadFile>

export async function UpdateCustomTemplateService (
  deviceId: string,
  file: File,
  deviceTemplateRequest: any,
  onSuccess: (UpdateCustomDevice: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('deviceTemplateRequest', '' + JSON.stringify(deviceTemplateRequest))
  const url = `/asset-config-service/api/v1/udp/tiq/commands/configuration/device-template/update/${deviceId}`
  interceptedAxios.put(url, formData)
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          const parsedData = parseResponse.data
          onSuccess(parsedData.data, response.status)
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        // istanbul ignore next
        onFailure((error.response.data !== undefined && error.response.data !== null) ? error.response.data.error_message : 'Network Error', error.response.status)
      } else {
        onFailure('Network Error', 404)
      }
    })
}
